import { cn } from '@/utils/commons';
import { BgColor, Size, TextColor } from '@/utils/types';
import { IconAlertTriangleFilled, IconCircleCheckFilled, IconInfoSquareRoundedFilled } from '@tabler/icons-react';

const iconMapping = {
  AlertTriangleFilled: IconAlertTriangleFilled,
  CircleCheckFilled: IconCircleCheckFilled,
  InfoSquareRoundedFilled: IconInfoSquareRoundedFilled,
};

export type IconsName = keyof typeof iconMapping;

export type IconProps = {
  icon: IconsName;
  size?: Size;
  iconColor?: TextColor;
  bgColor?: BgColor;
  isRounded?: boolean;
  className?: string;
};

export const Icon: React.FC<IconProps> = ({ icon, size = 'md', iconColor, bgColor, isRounded, className }) => {
  const SelectedIcon = iconMapping[icon];
  const hasBgColor = bgColor || className?.includes('bg-');

  const containerSize = {
    '2xl': 'w-12 h-12',
    xl: 'w-10 h-10',
    lg: 'w-9 h-9',
    md: 'w-8 h-8',
    sm: 'w-7 h-7',
    xs: 'w-6 h-6',
    xxs: 'w-5 h-5',
  }[size];

  const iconSize = {
    '2xl': 'w-7 h-7',
    xl: 'w-6 h-6',
    lg: 'w-[22px] h-[22px]',
    md: 'w-5 h-5',
    sm: 'w-[18px] h-[18px]',
    xs: 'w-4 h-4',
    xxs: 'w-3 h-3',
  }[size];

  return (
    <div
      className={cn(
        'inline-flex items-center justify-center',
        isRounded ? 'rounded-full' : 'rounded-md',
        bgColor,
        hasBgColor && `w-12 h-12 shadow ${containerSize}`,
        className
      )}
    >
      <SelectedIcon className={cn('flex-shrink-0', iconSize, iconColor && iconColor)} />
    </div>
  );
};
